import React from 'react';
import polkoBlack from "../../assets/logos/polko_black.svg"
import "./Footer.css"

function Footer() {

    return (
        <footer className="footer">
            <img src={polkoBlack} alt={"polko logo"} />
        </footer>
    );
}

export default Footer;